import { lazy } from "react";
import { FILM_CART_PUBLIC, LUMEN_PUBLIC } from "@/lib/flags";

const patron = () => import("@/pages/Patron");

const LUMEN_LOADERS = {
  "/lumen": () => import("@/pages/lumen/Lumen"),
  "/lumen/collection": () => import("@/pages/lumen/Collection"),
  "/lumen/collection/:id": () => import("@/pages/lumen/Shape"),
  "/lumen/engineering": () => import("@/pages/lumen/Engineering"),
  "/lumen/studio": () => import("@/pages/lumen/Studio"),
  "/lumen/commission": () => import("@/pages/lumen/Commission"),
};

const LOADERS = {
  "/technology": () => import("@/pages/Technology"),
  "/technology/projector-advisor": () => import("@/pages/advisor/Advisor"),
  "/lab": () => import("@/pages/Lab"),
  "/lab/inbox": () => import("@/pages/lab/Inbox"),
  "/lab/publish": () => import("@/pages/lab/Publish"),
  "/collaborate": () => import("@/pages/Collaborate"),
  "/archive": () => import("@/pages/threshold/archive/Archive"),
  "/archive/:slug": () => import("@/pages/threshold/archive/BriefPage"),
  "/makers": () => import("@/pages/Makers"),
  "/knowledge": () => import("@/pages/Knowledge"),
  "/submit": () => import("@/pages/Submit"),
  "/document": () => import("@/pages/Document"),
  "/threshold": () => import("@/pages/threshold/Threshold"),
  "/threshold/laboratory": () => import("@/pages/threshold/Laboratory"),
  "/threshold/atelier": () => import("@/pages/threshold/Atelier"),
  "/threshold/conversation": () => import("@/pages/threshold/Conversation"),
  "/threshold/advance": () => import("@/pages/threshold/Advance"),
  "/threshold/keeper": () => import("@/pages/threshold/keeper/Keeper"),
  "/threshold/archive": () => import("@/pages/threshold/archive/Archive"),
  "/threshold/archive/agenda": () => import("@/pages/threshold/archive/Agenda"),
  "/threshold/archive/anatomical-window": () => import("@/pages/threshold/archive/AnatomicalWindow"),
  "/threshold/archive/glass": () => import("@/pages/threshold/archive/glass/GlassResearch"),
  "/threshold/archive/brief/:slug": () => import("@/pages/threshold/archive/BriefPage"),
  "/about": () => import("@/pages/About"),
  "/patron": patron,
  "/about/testing": FILM_CART_PUBLIC ? () => import("@/pages/Configurator") : patron,
  "/about/testing/checkout": FILM_CART_PUBLIC ? () => import("@/pages/FilmCheckout") : patron,
  "/about/testing/admin": () => import("@/pages/QuotesAdmin"),
  "/payment/success": () => import("@/pages/PaymentSuccess"),
  "/payment/cancel": () => import("@/pages/PaymentCancel"),
  "/formulations": () => import("@/pages/formulations/Formulations"),
  "/samples": () => import("@/pages/Samples"),
  "/commons": () => import("@/pages/Commons"),
  "/topography": () => import("@/pages/LuminousTopography"),
  "/prism": () => import("@/pages/prism/Portal"),
  "/prism/vault": () => import("@/pages/prism/PrismIntelligence"),
  "/prism/paradigm": () => import("@/pages/prism/Paradigm"),
  "/films": () => import("@/pages/Films"),
  "/retrospective": () => import("@/pages/Retrospective"),
};

export const ROUTES = Object.entries({ ...LOADERS, ...(LUMEN_PUBLIC ? LUMEN_LOADERS : {}) }).map(([path, load]) => ({ path, Component: lazy(load) }));
export const ROUTE_PATHS = [{ path: "/" }, ...ROUTES.map(({ path }) => ({ path }))];

const warmed = new Set();

export function prefetchRoute(pathname) {
  const all = { ...LOADERS, ...(LUMEN_PUBLIC ? LUMEN_LOADERS : {}) };
  const key = all[pathname]
    ? pathname
    : pathname.startsWith("/threshold/archive/brief/")
      ? "/threshold/archive/brief/:slug"
      : pathname.startsWith("/archive/")
        ? "/archive/:slug"
        : LUMEN_PUBLIC && pathname.startsWith("/lumen/collection/")
          ? "/lumen/collection/:id"
          : null;
  if (!key || warmed.has(key)) return;
  warmed.add(key);
  all[key]().catch(() => warmed.delete(key));
}
